export default __webpack_public_path__ + "static/media/Detalles_01.3bd867d5.jpeg";